import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { SessionServiceFactory } from '@arc/unified-payments-frontend/shared-payment';
import {
  PoaSessionReviewPaymentActions,
  PoiSessionReviewPaymentActions,
  SessionActions,
} from '../actions';
import { UpdateRUMPaymentTagsAction } from '../actions/session.actions';
import {
  selectSessionId,
  selectSessionPaymentProcess,
} from '../selectors/session.selectors';
import { selectTenantId } from '../../external-selectors';
import { concatLatestFrom } from '@ngrx/operators';
import { HostedPaymentsReviewPaymentComponentSessionActions } from '../../component-actions';

@Injectable()
export class SessionPaymentEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private sessionServiceFactory: SessionServiceFactory,
  ) {}

  updatePayment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SessionActions.UpdatePaymentAction),
      concatLatestFrom(() => [
        this.store.select(selectTenantId),
        this.store.select(selectSessionId),
        this.store.select(selectSessionPaymentProcess),
      ]),
      exhaustMap(([action, tenantId, sessionId, paymentProcess]) =>
        this.sessionServiceFactory
          .create()
          .updatePaymentV1(tenantId, sessionId, action.request)
          .pipe(
            map((response) =>
              SessionActions.UpdatePaymentSuccessAction({
                response,
                paymentProcess,
              }),
            ),
            catchError((error: HttpErrorResponse) =>
              of(SessionActions.UpdatePaymentErrorAction({ error })),
            ),
          ),
      ),
    ),
  );

  updateRUMPayment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        SessionActions.UpdatePaymentSuccessAction,
        PoiSessionReviewPaymentActions.sessionPaymentUpdated,
        PoaSessionReviewPaymentActions.sessionPaymentUpdated,
        HostedPaymentsReviewPaymentComponentSessionActions.updateSessionPaymentSuccess,
      ),
      map((action) => {
        return UpdateRUMPaymentTagsAction({ payload: action.response });
      }),
    ),
  );
}
